<template>
  <el-container>
    <!-- 侧边导航 -->
    <el-aside width="167px">
      <div class="bg-color-w ht-all br-r-1">
        <div class="py-20 text-a-c fw-bold menuTitle">
          {{ drawerData.sysname }}
        </div>
        <div
          class="overf-y-a ht-all position-r"
          :style="asideStyle"
          v-scrollBar
        >
          <MenuNavigation
            :drawerData="drawerData"
            :activeindex="activeindex"
            :collapseArr="collapseArr"
            @isCommon="isCommon"
            @toSysUrl="toSysUrl"
            @getOneMenuUrl="getOneMenuUrl"
            @setCollapse="setCollapse"
          ></MenuNavigation>
        </div>
      </div>
    </el-aside>
    <el-container class="wt-all">
      <!-- 标题 -->
      <el-header class="pa-0">
        <div class="bg-color-w ht-62 dy-flex jy-c-sb">
          <div :xs="4" class="pl-30 dy-flex jy-c-sb align-i-c">
            <img :src="'/img/images/link/' + menu.img" class="wt-40 ht-40" />
            <div class="pl-10 fs-20">{{ title }}</div>
          </div>
          <!-- 中英文切换 -->
          <Languageqh v-if="$store.state.sysCs.sfqy_zywqh == '1'"></Languageqh>
        </div>
      </el-header>
      <!-- 内容 -->
      <el-main class="content">
        <el-row class="contentCard">
          <router-view></router-view>
          <!-- <iframe
          v-else
          ref="iframe"
          :src="url"
          width="100%"
          height="740px"
          frameborder="0"
          @load="iframeLoad()"
          :key="url"
        ></iframe> -->
        </el-row>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import * as yhxx from "@/api/yhxx";
import Languageqh from "@/components/Languageqh.vue";
import MenuNavigation from "@/components/MenuNavigation.vue";

export default {
  name: "qtxt",
  components: {
    Languageqh,
    MenuNavigation,
  },
  computed: {
    drawerData() {
      return this.$store.state.drawerData;
    },
    activeSpanStyle() {
      return {
        color: "#66B1FF",
        "font-weight": "500",
      };
    },
    asideStyle() {
      return {
        height: this.$store.state.screenHeight - 133 + "px",
      };
    },
    cardStyle() {
      return {
        width: this.$store.state.screenWidth - 287 - 40 + "px",
      };
    },
    textBtn() {
      return {
        padding: 0,
      };
    },
  },
  watch: {
    "$route.name"(val) {
      if (val != "/qtxtIframe") {
        if (
          this.$route.params.menu &&
          this.$route.params.menu.qname !== this.menu.qname
        ) {
          this.toSysUrl(
            this.$route.params.menu,
            this.$route.params.menus,
            this.$route.params.activeindex
          );
        } else {
          this.toSysUrl(this.menu, this.menuData, this.activeindex);
        }
      }
    },
  },
  data() {
    return {
      common2: "/img/images/star2.png",
      common1: "/img/images/star1.png",
      tableData: [],
      title: "",
      activeindex: "0",
      activQid: "",
      loading: false,
      menuData: [],
      menu: {},
      url: null,
      path: "",
      urlflg: "",
      flg: true,
      collapseArr: [],
    };
  },
  methods: {
    // 是否为常用
    isCommon(iscy, item) {
      let param = {
        yhbh: item.rydm,
        qid: item.qid,
        sysid: item.sysid,
      };
      if (iscy === "2") {
        yhxx.delMyCyMenu(param).then((res) => {
          item.iscy = "0";
          this.getMyMenu();
        });
      } else if (iscy === "1") {
        this.$message.error(this.$t("common.gdgnwfyc"));
      } else {
        yhxx.addMyCyMenu(param).then((res) => {
          item.iscy = "2";
          this.getMyMenu();
        });
      }
    },
    getRowKeys() {
      let key = Math.random();
      return key;
    },
    init() {
      this.url = this.$route.params.url;
      this.path = this.$route.name;
      this.menu = this.$route.params.menu;
      this.menuData = this.$route.params.menus;
      this.activeindex = this.$route.params.activeindex;
      if (this.menuData && this.menuData[0] !== "[object Object]") {
        this.$session.setItem("qtxtMenus", JSON.stringify(this.menuData));
      } else {
        this.menuData = JSON.parse(this.$session.getItem("qtxtMenus"));
      }
      if (this.menu && this.menu !== {}) {
        this.$session.setItem("qtxtMenu", JSON.stringify(this.menu));
      } else {
        this.menu = JSON.parse(this.$session.getItem("qtxtMenu"));
      }
      if (this.activeindex && this.activeindex != "") {
        this.$session.setItem("qtxtActiveindex", this.activeindex);
      } else {
        this.activeindex = this.$session.getItem("qtxtActiveindex");
      }
      if (this.path) {
        this.$session.setItem("activePath", JSON.stringify(this.path));
      } else {
        this.path = JSON.parse(this.$session.getItem("activePath"));
      }
      this.toSysUrl(this.menu, this.menuData, this.activeindex);
    },
    setactiveindex(index) {
      this.activeindex = index;
      this.$session.setItem(
        "qtxtActiveMenu",
        JSON.stringify(this.activeindex)
      );
      this.$router.push({
        name: "/qtxt",
        params: {},
      });
      this.toSysUrl();
    },
    iframeLoad() {
      // debugger;
      window.frames[0].postMessage("测试信息", this.url);
    },
    toSysUrl(item, items, index) {
      this.menu = item;
      this.activeindex = item.qid;
      this.menuData = items;
      this.$session.setItem("qtxtMenus", JSON.stringify(this.menuData));
      this.$session.setItem("qtxtMenu", JSON.stringify(this.menu));
      this.$session.setItem("qtxtActiveindex", this.activeindex);
      let menu = item;
      this.title = menu.qname;
      if (menu) {
        if (menu.urlflg == "0") {
          this.$router.push({
            name: menu.path,
            params: {
              title: this.title,
              activeindex: this.activeindex,
            },
          });
        } else {
          yhxx.getNewPageUrl(menu).then((res) => {
            let url = res.data.data;
            this.$store.commit("setIframeUrl", url);
            if (menu.urlflg == "1") {
              this.$router.push({
                name: "/qtxtIframe",
                params: {
                  title: this.title,
                  url: url,
                },
              });
            } else if (menu.urlflg == "2") {
              var newwindow = window.open(url);
            }
          });
          // }
        }
      }
    },
    getOneMenuUrl(item, index) {
      this.activeindex = item.qid;
      if (item.sysMenuList && item.sysMenuList.length > 0) {
        if (item.jc == "1") {
          let sys = item.sysMenuList[0];
          this.toSysUrl(sys, item, index);
        } else {
          this.toSysUrl(item, item, index);
        }
      } else {
        this.toSysUrl(item, item, index);
      }
    },
    // 设置悬浮菜单选项展开或折叠
    setCollapse(index) {
      if (this.collapseArr.includes(index)) {
        this.collapseArr.splice(
          this.collapseArr.findIndex((a) => a === index),
          1
        );
      } else {
        this.collapseArr.push(index);
      }
    },
    // 获取应用导航
    getMyMenu() {
      yhxx.getMyMenu().then((res) => {
        if (res.data.code == "200") {
          let menu = [];
          menu = res.data.data;
          this.$store.commit("yhxx/setMyMenu", res.data.data);
          menu.forEach((item) => {
            if (item.sysid === this.drawerData.sysid) {
              this.$store.commit("setDrawerData", item);
            }
          });
          // this.navigationData = res.data.data[i].sysMenuList;
          this.$store.commit(
            "navigation/setCyNavigationData",
            res.data.data[0].sysMenuList
          );
        }
      });
    },
  },
  beforeMount() {
    // window.addEventListener("message", function(evt) {});
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.menuTitle {
  border-bottom: 1px solid #ebeef5;
}
.br-r-1 {
  border-right: 1px solid #ebeef5;
}
.content {
  max-height: 100%;
}
// .menuList {
//   flex-direction: row;
//   flex-wrap: wrap;
//   flex: 1;
//   display: flex;
// }
.menuItem {
  display: flex;
  align-items: center;
  .rightClick {
    width: 20px;
    height: 20px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      display: none;
    }
  }
}
.menuItem:hover {
  background-color: #d9ecff;
  color: #183d76;
  .rightClick {
    img {
      display: block;
    }
  }
}
.oneMenu {
  font-size: 14px;
  color: #666666;
  width: 140px;
  height: 40px;
  padding: 5px 0px 5px 0px;
  display: flex;
  align-items: center;
}
.oneMenu:hover {
  background-color: #d9ecff;
  // color: #183d76;
}
.twoMenu {
  font-size: 14px;
  color: #666666;
  width: 140px;
  height: 40px;
  padding: 5px 0px 5px 10px;
  display: flex;
  align-items: center;
}
.contentCard {
  background-color: white;
  // transition: 1s;
}
</style>
